var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.516,
    height: 20,
    viewBox: "0 0 29.516 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Email_small",
    "data-name": "Email small",
    d: "M271.638,155.269v17.539l9.106-8.772C277.913,161.331,273.89,157.444,271.638,155.269Zm13.421,10.5a1.972,1.972,0,0,0,2.849-.215c1.117-1.11,8.671-8.284,12.035-11.474H272.852C278.361,159.412,284.418,165.239,285.059,165.773Zm6.868-1.727,9.228,8.89V155.272C298.843,157.463,294.721,161.377,291.927,164.047Zm-2.779,2.669a3.9,3.9,0,0,1-2.765,1.228,3.853,3.853,0,0,1-2.453-.912c-.2-.168-.859-.78-1.958-1.825l-9.214,8.877H299.9l-9.206-8.866C289.877,166,289.371,166.5,289.147,166.716Z",
    transform: "translate(-271.638 -154.084)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsmall);
export default __webpack_public_path__ + "static/media/Email small.2611ec5e49f031a4c42e336552d898f8.svg";
export { ForwardRef as ReactComponent };